import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-3 rounded-2xl bg-white p-4 shadow-md w-full overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "min-w-8"
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "text-xl font-semibold leading-snug tracking-tighter truncate" }
const _hoisted_5 = {
  key: 0,
  class: "ml-0.5 text-xs font-medium text-gray-400"
}
const _hoisted_6 = { class: "text-sm text-gray-600 leading-tight truncate" }

import { computed } from 'vue';
import { i18n } from '@/plugins/internationalization/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WeekKpi',
  props: {
    label: {},
    value: {},
    suffix: {},
    iconId: {},
    fixedDecimals: {}
  },
  setup(__props: any) {

const props = __props;

const hasValue = computed(() => Number.isFinite(props.value));

const formattedValue = computed(() => {
    if (!hasValue.value) return '—';
    const rounded = Number(props.value.toFixed(1));
    if (props.fixedDecimals === undefined) return i18n.global.n(rounded, 'decimal');
    return i18n.global.n(rounded, { style: 'decimal', minimumFractionDigits: props.fixedDecimals, maximumFractionDigits: props.fixedDecimals });
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.iconId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            class: "h-8 w-8",
            src: _ctx.iconId
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(formattedValue.value), 1),
        (_ctx.suffix && hasValue.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.suffix), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.label), 1)
    ])
  ]))
}
}

})